import ChallengeTypeSettings from './ChallengeTypeSettings';

export default ChallengeTypeSettings;
